import lottie from "lottie-web";
import VanillaTilt from "vanilla-tilt";
import Hls from "hls.js";

document.querySelectorAll("*[data-animation]").forEach(el => {
  if (!(el.dataset && el.dataset.animation)) return;

  lottie.loadAnimation({
    container: el,
    renderer: 'svg',
    path: el.dataset.animation,
    autoplay: true,
    loop: el.dataset.nonLoop || true
  });
});

VanillaTilt.init(document.querySelectorAll(".composite-icon"), {
  max: 10,
  speed: 400,
  reverse: true
});

document.querySelectorAll("[data-stream]").forEach(el => {
  if (Hls.isSupported()) {
    var hls = new Hls();

    hls.loadSource(el.dataset.stream);
    hls.attachMedia(el);
    hls.on(Hls.Events.MANIFEST_PARSED, function() {
      el.play();
    });
  }
});
